import { render, staticRenderFns } from "./ProtocolsActItems.vue?vue&type=template&id=7935de22&"
import script from "./ProtocolsActItems.vue?vue&type=script&lang=js&"
export * from "./ProtocolsActItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports